import React, { useState, useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './connection-log-app';
import ErrorBoundary from './components/ErrorBoundary';
import SplashAnimation from './components/SplashAnimation';
import { SA_LOGO } from './utils/saLogo';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { startLiveUpdates } from './utils/liveUpdate';
import reportWebVitals from './reportWebVitals';

if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

function Root() {
  const [splashDone, setSplashDone] = useState(false);
  const isNative = Capacitor.isNativePlatform();

  const handleSplashDone = useCallback(() => setSplashDone(true), []);

  // Hide the native static splash as soon as React is ready so our animated
  // splash takes over seamlessly (same #060912 background, no visible gap).
  React.useEffect(() => {
    if (!isNative) return;
    SplashScreen.hide({ fadeOutDuration: 150 }).catch(() => {});
    // Live updates: confirm this bundle booted. Without it, the plugin assumes the
    // update is broken and rolls back to the previous bundle after 10s.
    CapacitorUpdater.notifyAppReady().catch(() => {});
    startLiveUpdates();
  }, [isNative]);

  return (
    <>
      {isNative && !splashDone && (
        <SplashAnimation logo={SA_LOGO} onDone={handleSplashDone} />
      )}
      <App />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Root />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
